import { render, staticRenderFns } from "./Absence.vue?vue&type=template&id=38e63d10&"
import script from "./absence?vue&type=script&lang=js&"
export * from "./absence?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports